import React from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles } from "lucide-react";

const ITEMS = [
  "MONEY-BACK GUARANTEE",
  "Complete your committed daily study plan & mock milestones",
  "Not eligible for results? Get your course fee refunded",
  "Eligibility-based · Terms apply",
];

export const AnnouncementBanner = () => (
  <Link
    to="/success-guarantee"
    className="fixed top-0 inset-x-0 z-[60] block h-9 overflow-hidden bg-gradient-to-r from-amber-400 via-orange-500 to-red-600 text-white"
    data-testid="moneyback-banner"
    aria-label="Money-back guarantee — view terms"
  >
    <Marquee gradient={false} speed={55} autoFill className="h-9">
      {ITEMS.map((t, i) => (
        <span
          key={t}
          className="mx-6 flex h-9 items-center gap-2 text-[11px] sm:text-xs font-display font-semibold uppercase tracking-widest"
        >
          {i === 0 ? <ShieldCheck className="h-3.5 w-3.5" /> : <Sparkles className="h-3 w-3 text-white/70" />}
          {t}
        </span>
      ))}
    </Marquee>
  </Link>
);
